module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLightItalic.78871f48.woff2";